import type { DesignTokens, ExtendedCSS, ExtendedTokens } from '@primeuix/themes/types';

interface Style<T> {
    style: T;
    extend?: ExtendedTokens;
    css?: ExtendedCSS;
}

export interface ComponentsDesignTokensWithColorScheme<T> {
    colorScheme: {
        light: T;
    };
}

export function componentStyle<T>(designTokens: T): ComponentsDesignTokensWithColorScheme<T> {
    return {
        colorScheme: {
            light: designTokens,
        },
    };
}

export function componentStyleWithExtend<T>(style: Style<T>): DesignTokens<T> {
    return {
        colorScheme: {
            light: style.style,
        },
        extend: style.extend,
        css: style.css,
    };
}
